import _ from "lodash";

export class CsatRatingEntity {
    constructor(props) {
        this.props = props;
    }

    setLastScoreCsatReaction() {
        const reactions = {
            0: {
                label: "Valorizo Neutro",
                icon: "far fa-meh"
            },
            [-1]: {
                label: "Valorizo Pouco",
                icon: "far fa-frown"
            },
            1: {
                label: "Valorizo Muito",
                icon: "far fa-smile"
            }
        };

        const answeredCsat = this.props.csat.filter((c) =>
            _.get(c, "events.answered")
        );
        if (!answeredCsat.length)
            return (this.props.lastCsatReaction = { label: "Sem resposta" });

        this.props.lastCsatReaction = reactions[this.props.lastCsat.score] || {
            label: "Sem resposta"
        };
    }

    setTagEmailCompany() {
        this.props.emailCompanyTag = `<${this.props.email}>`;
    }

    setHiddenCSAT(status = null) {
        if (status !== null) this.props.hiddenCSAT = status;
        if (typeof this.props.hiddenCSAT === "undefined")
            this.props.hiddenCSAT = false;
    }
}
